import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Switch } from "@material-ui/core";
import { useImpactFormDisabled } from "app/routes/psp/management/useImpactReadOnly";

function FormSwitch(props) {
  const { control } = useFormContext();
  const { name, label, disabled } = props;
  const isDisabled = useImpactFormDisabled(disabled);

  return (
    <FormControlLabel
      control={
        <Controller
          control={control}
          name={name}
          defaultValue={false}
          render={({ onChange, value }) => (
            <Switch
              color="primary"
              onChange={(e) => onChange(e.target.checked)}
              checked={value}
              disabled={isDisabled}
            />
          )}
        />
      }
      label={label}
      disabled={isDisabled}
    />
  );
}

export default FormSwitch;
